import { gqlFetcher, graphql } from '#features/api';
import { persistNativeAuthResult } from '#features/api/utils/nativeAuth';

const loginDoc = graphql(`
  mutation Login($input: LoginInput!) {
    auth {
      login(input: $input) {
        __typename
        ... on Token {
          token
        }
        ... on GlobalError {
          errorCode
          errorMessage
        }
      }
    }
  }
`);

export const doLogin = (input: { email: string; password: string }) =>
  gqlFetcher(loginDoc, { input }).then(async (data) => {
    const result = data?.auth?.login;
    await persistNativeAuthResult(result);
    return result;
  });
